module.exports = __webpack_public_path__ + "media/20. Scattle - Inner Animal.f68dd9fe.mp3";